export default "__VITE_ASSET__DvPzqCRZ__"